import { useEffect, useRef } from 'react';
import { useAuth, useDomainEvent, useEvent, useLazyQuery } from '@soap/modules';
import { REFETCH_C302_DOMAIN_EVENT } from '../../modules/lyw-auth-events';
import type { TodoDto } from '../components/TodoPanel';

/**
 * Loads setup todos for the Dashboard. Refetches on each Dashboard visit (no stale cache)
 * and while the Dashboard is open when E304v1_TodoCompleted fires (e.g. dismiss link).
 */
export function useLywUserTodos(): TodoDto[] {
  const { authReady, isAuthenticated } = useAuth('useLywUserTodos');
  const [getUserTodos, queryResult] = useLazyQuery('C302v1_GetUserTodos', null);
  const initialFetchSentRef = useRef(false);
  const todos: TodoDto[] =
    queryResult === undefined ? [] : (queryResult.e302_Todos ?? []);

  useEvent({
    eventName: 'E304v1_TodoCompleted',
    onEventReceived: () => {
      getUserTodos?.(undefined, 0);
    },
  });

  useDomainEvent({
    eventName: REFETCH_C302_DOMAIN_EVENT,
    onEventReceived: () => {
      getUserTodos?.(undefined, 0);
    },
  });

  useEffect(() => {
    if (!authReady || !isAuthenticated || initialFetchSentRef.current) {
      return;
    }
    initialFetchSentRef.current = true;
    getUserTodos?.(undefined, 0);
  }, [authReady, isAuthenticated, getUserTodos]);

  return todos;
}
